import MachineDetails from "./MachineDetails";
export default MachineDetails;